"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.block = exports.UIKIT = void 0;
var bem_cn_1 = require("bem-cn");
exports.UIKIT = "emankit";
exports.block = bem_cn_1.setup({
    ns: exports.UIKIT + "__",
    mod: "--",
});
//# sourceMappingURL=config.js.map